import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cls from "./Hero.module.scss";
export default function Hero() {
    const handleContactClick = (e) => {
        e.preventDefault();
        const element = document.querySelector("#contact");
        if (element) {
            const headerOffset = 80;
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        }
    };
    return (_jsxs("section", { className: cls.hero, children: [_jsx("div", { className: cls.backgroundImage }), _jsx("div", { className: cls.content, children: _jsxs("div", { className: cls.textContent, children: [_jsx("h1", { className: cls.heading, children: "Performance Marketing Focused on Real Business Outcomes" }), _jsxs("div", { className: cls.textBlock, children: [_jsx("p", { children: "We help brands scale through data-driven digital advertising and CPA-based campaigns designed to convert." }), _jsx("p", { children: "You pay only for what truly matters \u2014 leads, installs, sales, and subscriptions." })] }), _jsx("a", { href: "#contact", className: cls.button, onClick: handleContactClick, children: "Contact Our Team" })] }) })] }));
}
